import React from "react";
import { PaymentMethodT } from "../../data/available-payment-methods";
import { PaymentIcon } from "./PaymentIcon";
import { CCState } from "./types";
import { CheckoutSelectionState } from "../../state/type";
import { OpenedPaymentMethod } from "./CheckoutPaymentMethod";

export function getPaymentMethodsIconComponent(
  brands: Array<string>,
  screen: CCState,
  openedPaymentMethod: OpenedPaymentMethod,
) {
  const possibleCCs = brands.map(brand => <PaymentIcon paymentName={brand} key={brand} />);

  switch (screen.tag) {
    case "input-card-data": {
      if (openedPaymentMethod?.tag === "credit-card") {
        return null;
      } else {
        return possibleCCs;
      }
    }
    case "show-saved-card": {
      if (screen.data.brand) {
        return <PaymentIcon paymentName={screen.data.brand.brand} />;
      }

      return possibleCCs;
    }
    default: {
      const _: never = screen;
      return _;
    }
  }
}
